import z from 'zod';

import { client } from '~shared/api';

import { LimitDtoSchema, LimitUpdateDto } from '../dto';

export async function fetchListLimits(sectionId: number) {
	const data = await client.get(`/limit/section/${sectionId}`);
	return z.array(LimitDtoSchema).parse(data);
}

export async function updateLimitsBySection(sectionId: number, limits: LimitUpdateDto[]) {
	await client.put(`/limit/section/${sectionId}`, limits);
}
